import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from 'react';
const ApiRouteMonitorContext = createContext(undefined);
export const useApiRouteMonitor = () => {
    const context = useContext(ApiRouteMonitorContext);
    if (context === undefined) {
        throw new Error('useApiRouteMonitor must be used within an ApiRouteMonitorProvider');
    }
    return context;
};
export const ApiRouteMonitorProvider = ({ children }) => {
    const [routeStatuses, setRouteStatuses] = useState(new Map());
    const updateRouteStatus = useCallback((route, status) => {
        setRouteStatuses(prev => {
            const newMap = new Map(prev);
            newMap.set(route, {
                ...status,
                route,
                lastAccessed: new Date(),
            });
            return newMap;
        });
    }, []);
    const getRouteStatus = useCallback((route) => {
        return routeStatuses.get(route);
    }, [routeStatuses]);
    const clearRouteStatuses = useCallback(() => {
        setRouteStatuses(new Map());
    }, []);
    const value = {
        routeStatuses,
        updateRouteStatus,
        getRouteStatus,
        clearRouteStatuses,
    };
    return (_jsx(ApiRouteMonitorContext.Provider, { value: value, children: children }));
};
